import { Methods } from '@api/group/category';
import { Request } from '../../request';
export default async (query:Methods["get"]["query"]) => Request( client => client.group.category.$get({query}) )
